<script>

</script>
<div>
    <h1>BACHELORGRUPPE 2</h1>
    <h2>System for behandling av XML-meldinger</h2>
</div>

<style>
    h1 {
        color: black;
        text-transform: uppercase;
        font-size: 3em;
        font-family: 'Arial', sans-serif;
        margin: 0;
        padding-bottom: 0;
        wrap-option: nowrap;
    }

    h2 {
        color: black;
        margin-top: 1em;
        font-size: 1.5em;
        font-weight: 100;
        font-family: 'Arial', sans-serif;
    }

    div {
        display: flex;
        flex-flow: column wrap;
        justify-content: center;
        background-color: white;
        flex: 0 0 100%;
        padding: 2em 0;
        margin: 3em 0;
        min-height: 10em;
    }
</style>
